import {AGENT_MERGE_ACTIONS, type AgentMergeAction} from './agent-merge'

export type AgentMergeActiveSession = {
  id: string
  url: string
  /** `null` for sessions started before sweagentd began tagging the action. */
  action: AgentMergeAction | null
  goal?: string
}

export type AgentMergeSessionResponse = {
  activeSession: AgentMergeActiveSession | null
}

function isAgentMergeAction(action: unknown): action is AgentMergeAction {
  return AGENT_MERGE_ACTIONS.some(candidate => candidate === action)
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}

/**
 * Validates the session endpoint's response at runtime. This endpoint has no generated schema, so
 * this is the only guard between the raw JSON and the rest of the section: anything unrecognized
 * degrades to "no active session" rather than throwing and taking out the Agent Merge section.
 */
export function normalizeAgentMergeSession(response: unknown): AgentMergeSessionResponse {
  if (!isRecord(response)) return {activeSession: null}

  const session = response.activeSession
  if (!isRecord(session) || typeof session.id !== 'string' || typeof session.url !== 'string') {
    return {activeSession: null}
  }

  return {
    activeSession: {
      id: session.id,
      url: session.url,
      action: isAgentMergeAction(session.action) ? session.action : null,
      ...(typeof session.goal === 'string' && session.goal.trim() ? {goal: session.goal} : {}),
    },
  }
}
